import styled from 'styled-components';
import type { BoxProps } from '@usealloy/component-library';
import {
  Badge,
  Box,
  Button,
  Collapse,
  Text,
} from '@usealloy/component-library';
import TextConcealer from '~/workflow/workflowTestHistory/components/TextConcealer';

export const modalMaxHeight = 616;

interface TabProps extends BoxProps {
  isSelected: boolean;
}

export const ModalBodyWrapper = styled(Box)`
  && {
    height: ${modalMaxHeight - 50}px;
    max-height: ${modalMaxHeight - 50}px;
    overflow-y: hidden;
  }
`;

export const ModalTabWrapper = styled(Box)`
  && {
    border-right: 1px solid var(--cl-border-secondary);
    height: 100%;
    max-height: 100%;
    overflow-y: scroll;
    padding: 1px var(--cl-space-2) 0 1px;
    min-width: 220px;
    max-width: 220px;
  }
`;

export const ModalContentWrapper = styled(Box)`
  && {
    height: 100%;
    max-height: 100%;
    overflow-y: scroll;
    overflow-x: scroll;
    padding: 0;
    min-width: 620px;
  }
`;

export const Tab = styled(Box)<TabProps>`
  && {
    border-radius: var(--cl-radius-3);
    height: var(--cl-space-14);
    padding: var(--cl-space-4) var(--cl-space-2);
    background-color: ${({ isSelected }) => (isSelected ? 'var(--cl-gray-300)' : 'inherit')};
    &:hover {
      cursor: pointer;
      background: var(--cl-gray-200);
    }
  }
`;

export const TabCount = styled(Badge)`
  && {
    border-radius: 27px;
    background-color: var(--cl-gray-400);
    justify-content: center;
  }
`;

export const StyledCollapse = styled(Collapse)`
  && {
    border: none;
    width: 100%;
    &>div {
      padding: 0;
    }
    &>:first-child {
      background-color: var(--cl-gray-200);
      border-radius: var(--cl-radius-3);
      margin-bottom: var(--cl-space-1);
      margin-left: calc(-1 * (620px - (100% - var(--cl-space-2))));
      margin-right: 0;
      padding-left: calc((620px - (100% - var(--cl-space-2))));
      padding-right: 0;
      width: calc(100% - var(--cl-space-2));
    }
  }
`;

export const MetadataItemWrapper = styled(Box)`
  && {
    margin: 0 0 var(--cl-space-1) 0;
    padding: var(--cl-space-3) var(--cl-space-2);
    width: 100%;
  }
`;

export const CollapseChildrenWrapper = styled(Box)`
  && {
    padding-left: var(--cl-space-10);
    width: 100%;
  }
`;

export const NoDataWrapper = styled(Box)`
  && {
    height: 100%;
    width: 100%;
  }
`;

export const CheckboxToggleWrapper = styled(Box)`
  && {
    padding-right: var(--cl-space-6);
    width: max-content;
  }
`;

export const ToggleParentKeys = styled(Button)`
  && {
    max-height: 18px;
    padding-bottom: 0;
    padding-top: 0;
  }
`;

export const ModalValueText = styled(Text)`
  && {
    max-width: 100%;
    min-width: 220px;
    word-break: keep-all;
  }
`;

export const ModalConcealerText = styled(TextConcealer)`
  && {
    color: var(--cl-text-default);
    font-size: var(--cl-font-size-2);
    font-weight: var(--cl-font-weight-regular);
    line-height: var(--cl-font-size-2);
    max-width: 100%;
    min-width: 220px;
    word-break: break-word;
  }
`;

// Styles for MetaData.jsx:

export const LineBox = styled(Box)`
  &&&& {
    line-height: var(--cl-line-height-5);
    max-width: 100%;
    width: 100%;
  }
`;

export const MetaKeyText = styled(Text)`
  &&&& {
    white-space: normal;
    min-width: fit-content;
  }
`;
export const MetaValueText = styled(Text)`
  &&&& {
    max-width: 400px;
    overflow-wrap: break-word;
    white-space: normal;
  }
`;
